// [BD Feat] JS for the collection hero section slider

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collection-slider-products[data-section-id]').forEach(function (sectionWrapper) {
      var sectionId = sectionWrapper.getAttribute('data-section-id');
      if (!sectionId) return;
      var slideSpeed = Number(sectionWrapper.getAttribute('data-slide-speed')) || 5000;
      var autoplay = sectionWrapper.getAttribute('data-autoplay') === 'true';
  
      var collectionNamesList = document.querySelector(`#collections-names-${sectionId}`);
      var collectionNameItems = collectionNamesList?.querySelectorAll('.collection-name') || [];
  
      const tabsLoop = checkChildWidth(collectionNamesList, collectionNameItems);
  
      var collectionsSlider = new Flickity(`#collections-slider-${sectionId}`, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        groupCells: 1,
        wrapAround: true,
        autoPlay: autoplay ? slideSpeed : false
      });
  
      var flktyCollectionsNames = new Flickity(`#collections-names-${sectionId}`, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: tabsLoop,
        selectedIndex: 0
      });
  
      var syncing = false;
  
      flktyCollectionsNames.on('staticClick', function (event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex !== 'undefined') {
          flktyCollectionsNames.select(cellIndex, true, false);
        }
      });
  
      collectionsSlider.on('select', function () {
        if (!syncing) {
          syncing = true;
          flktyCollectionsNames.select(collectionsSlider.selectedIndex);
          syncing = false;
        }
      });
  
      flktyCollectionsNames.on('select', function () {
        if (!syncing) {
          syncing = true;
          collectionsSlider.select(flktyCollectionsNames.selectedIndex);
          syncing = false;
        }
      });
  
  
      // Initial Load
      var firstSlide = document.querySelector(`#collections-slider-${sectionId} .collection-slide`);
      if (firstSlide) {
        
        if (collectionNameItems.length > 0) {
          collectionNameItems[0].classList.add('active');
        }
        
      }
  
      document.addEventListener('shopify:section:load', function (event) {
        collectionsSlider.reloadCells();
        flktyCollectionsNames.reloadCells();
      });
  
      // Check child width function (same for all)
      function checkChildWidth(parentElement, childElements) {
        try {
          const parentWidth = parentElement.offsetWidth;
          let totalChildWidth = 0;
  
          childElements.forEach((child, index) => {
            const childWidth = child.offsetWidth;
            const style = window.getComputedStyle(child);
            const marginRight = parseInt(style.marginRight, 10) || 0;
  
            if (index < childElements.length - 1) {
              totalChildWidth += childWidth + marginRight;
            } else {
              totalChildWidth += childWidth;
            }
          });
  
          return totalChildWidth > parentWidth;
        } catch (error) {
          console.error("Error in checkChildWidth:", error);
          return false;
        }
      }
    });
  });
  